module.exports = __webpack_public_path__ + "static/assets/5b047cd8fef4e5e2d83ece72fb3ad656.svg";